const envVariables = import.meta.env;

//Url des APIS
const API_CENTRE = envVariables.VITE_API_CENTRE_URL;
const API_GESTIONCENTRALE = envVariables.VITE_API_GATEWAY_URL;

// WORKPLACE supprimé - fusionné dans CentrePorcin
// const API_WORKPLACE = envVariables.VITE_API_WORKPLACE_URL;

// CUSTOMER supprimé - microservice non utilisé
// const API_CUSTOMER = envVariables.VITE_API_CUSTOMER_URL;

// BFF supprimé - DMS migré vers CentrePorcin
// let API_BFF = envVariables.VITE_BFF_URL;

// DMS Model ids
const DMS_DILUTOR_BATH_MODEL_REF = envVariables.VITE_DMS_DILUTOR_BATH_MODEL_REF;
const DMS_ORDER_MODEL_REF = envVariables.VITE_DMS_ORDER_MODEL_REF;
const DMS_PREPARATION_MODEL_REF = envVariables.VITE_DMS_PREPARATION_MODEL_REF;
const DMS_REFORM_MODEL_REF = envVariables.VITE_DMS_REFORM_MODEL_REF;
const DMS_RESERVATION_MODEL_REF = envVariables.VITE_DMS_RESERVATION_MODEL_REF;
const DMS_EVENEMENT_MODEL_REF = envVariables.VITE_DMS_EVENEMENT_MODEL_REF;

const ENV_NAME = envVariables.VITE_ENVNAME;
const ENV_CENTERNAME = envVariables.VITE_CENTERNAME;

//Export des URL API
export {
    // API_BFF supprimé - DMS migré vers CentrePorcin
    API_CENTRE,
    API_GESTIONCENTRALE,
    // API_WORKPLACE supprimé - fusionné dans CentrePorcin
    // API_CUSTOMER supprimé - microservice non utilisé

    ENV_NAME,
    ENV_CENTERNAME,

    DMS_DILUTOR_BATH_MODEL_REF,
    DMS_ORDER_MODEL_REF,
    DMS_PREPARATION_MODEL_REF,
    DMS_REFORM_MODEL_REF,
    DMS_RESERVATION_MODEL_REF,
    DMS_EVENEMENT_MODEL_REF
};
